import { useInvitationsStore } from 'store/modules';

export default function (to, from, next) {
    const { getOrganizationInvitesById } = useInvitationsStore();

    // If the request invitation is invalid, redirect to the generic login page.
    if (to.matched.some((record) => record.meta.invitation)) {
        getOrganizationInvitesById(to.params.id)
            .then(() => {
                next();
            })
            .catch(() => {
                next('/auth/login');
            });
    } else {
        next();
    }
}
